import React, { createContext, ReactNode } from 'react';

type SellFormFlatRateExpContextType = {
  sellFormFlatRateDropdownExpEnabled: boolean;
};

export const SellFormFlatRateExpContext = createContext<SellFormFlatRateExpContextType | undefined>(undefined);

type SellFormFlatRateExpProviderProps = {
  children: ReactNode;
  sellFormFlatRateDropdownExpEnabled: boolean;
};

export const SellFormFlatRateExpProvider = ({
  children,
  sellFormFlatRateDropdownExpEnabled,
}: SellFormFlatRateExpProviderProps) => {
  return (
    <SellFormFlatRateExpContext.Provider value={{ sellFormFlatRateDropdownExpEnabled }}>
      {children}
    </SellFormFlatRateExpContext.Provider>
  );
};
